import bannerImg from './banners/woman-helping-man-gym.jpg';

export default {
    id: 'nps-programa-treino',
    title: 'NPS — Programa de treino',
    description: 'Meça o Net Promoter Score do seu programa de treinos e colete insights rápidos dos seus alunos.',
    indicatedFor: 'Personal trainers',
    stepsCount: 1,
    questionsSummary: ['Nota de recomendação', 'Motivo da nota', 'Maior resultado', 'Sugestão de melhoria'],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: 'Avalie o programa de treinos',
        active: false,
        allow_multiple_answers: false,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: 'Sua avaliação',
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: 'Enviar',
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'scale',
                        label: 'De 1 a 5, o quanto você recomendaria este programa para um amigo?',
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: 'Não recomendaria',
                            maxLabel: 'Com certeza recomendo',
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 2,
                        type: 'text',
                        label: 'Por que você deu essa nota?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 3,
                        type: 'text',
                        label: 'Qual foi o maior resultado que você obteve com o programa?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: 'O que você mudaria ou melhoraria no programa?',
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
};
